export default "__VITE_ASSET__84a8a1e1__"